{
    "Profile_Drivers.drivers": "Drivers",
    "Profile_Drivers.driver": "Driver {number}"
}
